import React from 'react';
import { Button, IconButton, List, ListItemButton, ListItemText, Paper, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import * as api from '../plannerApi';
import { EmptyState, Loader, useLoad } from '../common';

/** The household's stores. */
const StoresPage: React.FC = () => {
  const navigate = useNavigate();
  const { data: stores, error, loading, reload } = useLoad(() => api.getStores());

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <IconButton aria-label="Voltar" onClick={() => navigate('/casa/compras')}><ArrowBackIcon /></IconButton>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 600, flexGrow: 1 }}>Lojas</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/casa/compras/lojas/nova')}>Nova</Button>
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Onde fazes compras. Cada loja tem a ordem dos seus corredores, usada no modo loja.
      </Typography>
      <Loader loading={loading} error={error} onRetry={reload} hasData={stores !== undefined}>
        {stores && stores.length === 0 && (
          <EmptyState title="Ainda não há lojas" text="Usa «Nova» para juntar a primeira." />
        )}
        {stores && stores.length > 0 && (
          <Paper variant="outlined">
            <List disablePadding>
              {stores.map(s => (
                <ListItemButton key={s.publicId} divider onClick={() => navigate(`/casa/compras/lojas/${s.publicId}`)}>
                  <ListItemText
                    primary={s.name}
                    secondary={s.isDefault ? 'loja habitual' : undefined}
                    slotProps={{ primary: { fontWeight: 600 } }}
                  />
                </ListItemButton>
              ))}
            </List>
          </Paper>
        )}
      </Loader>
    </>
  );
};

export default StoresPage;
